import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectActiveServiceIndex, selectDisablePromotionSection } from '../../../../../../../selectors/publishTerms';
import { selectIsBetPositionVisible } from '../../../../../../../selectors/betPosition';
import { selectIsMobileLayout } from '../../../../../../../selectors/layout';

import { ServicesSlider } from './components/ServicesSlider';
import { ServiceContainer } from './components/Services/ServiceContainer';

import { useServicesAnalytics } from '../hooks';

import * as styles from './Services.container.css';
import { selectServiceIds } from '../../../../../../../reducers/v2/promotion/selectors';

export const ServicesContainer = () => {
  const serviceIds = useSelector(selectServiceIds);
  const activeServiceIndex = useSelector(selectActiveServiceIndex);
  const isBetPositionVisible = useSelector(selectIsBetPositionVisible);
  const allowDisablePromotionSection = useSelector(selectDisablePromotionSection);
  const isMobile = useSelector(selectIsMobileLayout);

  const { trackSliderScroll } = useServicesAnalytics();

  const handleScrollSliderRight = React.useCallback(() => {
    trackSliderScroll('right');
  }, [trackSliderScroll]);

  const handleScrollSliderLeft = React.useCallback(() => {
    trackSliderScroll('left');
  }, [trackSliderScroll]);

  const Services = serviceIds.map(serviceId => <ServiceContainer key={serviceId} serviceId={serviceId} />);

  if (isMobile) {
    return <div className={styles.services}>{Services}</div>;
  }

  return (
    <ServicesSlider
      isMobile={isMobile}
      isBetPositionVisible={isBetPositionVisible}
      activeServiceIndex={activeServiceIndex}
      onScrollSliderRight={handleScrollSliderRight}
      onScrollSliderLeft={handleScrollSliderLeft}
      disabled={allowDisablePromotionSection}
    >
      {Services}
    </ServicesSlider>
  );
};
